import { gql } from '@apollo/client';
import { CRM_BOARD_FIELDS } from './queries';

const CRM_BOARD_PIPELINE_FIELDS = `
    _id
    boardId
    name
    order
    stages {
        key
        name
        order
        color
        isWon
        isLost
        statuses {
            label
            fromDays
            toDays
            color
        }
    }
`;

/* boards */

export const CREATE_CRM_BOARD = gql`
    mutation CreateCrmBoard($input: CreateCrmBoardInput!) {
        createCrmBoard(input: $input) {
            ${CRM_BOARD_FIELDS}
        }
    }
`;

export const UPDATE_CRM_BOARD = gql`
    mutation UpdateCrmBoard($input: UpdateCrmBoardInput!) {
        updateCrmBoard(input: $input) {
            ${CRM_BOARD_FIELDS}
        }
    }
`;

export const REORDER_CRM_BOARDS = gql`
    mutation ReorderCrmBoards($input: ReorderCrmBoardsInput!) {
        reorderCrmBoards(input: $input) {
            ${CRM_BOARD_FIELDS}
        }
    }
`;

export const SET_CRM_BOARD_STATUS = gql`
    mutation SetCrmBoardStatus($boardId: String!, $status: String!) {
        setCrmBoardStatus(boardId: $boardId, status: $status) {
            ${CRM_BOARD_FIELDS}
        }
    }
`;

export const DELETE_CRM_BOARD = gql`
    mutation DeleteCrmBoard($boardId: String!) {
        deleteCrmBoard(boardId: $boardId)
    }
`;

/* pipelines within a board */

export const CREATE_CRM_PIPELINE = gql`
    mutation CreateCrmPipeline($input: CreateCrmPipelineInput!) {
        createCrmPipeline(input: $input) {
            ${CRM_BOARD_PIPELINE_FIELDS}
        }
    }
`;

export const UPDATE_CRM_BOARD_PIPELINE = gql`
    mutation UpdateCrmBoardPipeline($input: UpdateCrmBoardPipelineInput!) {
        updateCrmBoardPipeline(input: $input) {
            ${CRM_BOARD_PIPELINE_FIELDS}
        }
    }
`;

export const REORDER_CRM_PIPELINES = gql`
    mutation ReorderCrmPipelines($input: ReorderCrmPipelinesInput!) {
        reorderCrmPipelines(input: $input) {
            ${CRM_BOARD_PIPELINE_FIELDS}
        }
    }
`;

/* placing an automation onto a stage */

export const PLACE_CRM_AUTOMATION = gql`
    mutation PlaceCrmAutomation($input: PlaceCrmAutomationInput!) {
        placeCrmAutomation(input: $input) {
            _id
            name
            status
            pipelineId
            stageKey
            order
        }
    }
`;

/* manual "Add to board" — a business or contact onto a chosen stage */

export const PLACE_CRM_ON_BOARD = gql`
    mutation PlaceCrmOnBoard($input: PlaceCrmOnBoardInput!) {
        placeCrmOnBoard(input: $input) {
            targetKind
            targetId
            stageKey
            pipelineId
        }
    }
`;
